/**
 * External applications configuration.
 * Defines base URLs per environment for cross-app navigation.
 */

type Environment = "local" | "qa" | "prod";

interface ExternalApp {
  urls: Record<Environment, string>;
}

const ACQUISITIONS: ExternalApp = {
  urls: {
    local: "http://localhost:3000",
    qa:    "https://acquisitions.llavero.co",
    prod:  "https://acquisitions.habi.co",
  },
};

const getEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1") return "local";
  if (hostname.includes("llavero.co")) return "qa";
  return "prod";
};

export const getLauncherUrl = (path = "/launch"): string => {
  const env = getEnvironment();
  return `${ACQUISITIONS.urls[env]}${path}`;
};
